import * as ng from 'angular';

class RenewSubscriptionSummaryController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
    ) {

        let user = store.get('user');

        if ($rootScope.userTypes[user.subscription.subscriptionType] !== 'archismall') {
            $scope.goToIndex();
        }

        $scope.goToIndex = () => {
            $state.go('unsubscription.unsubscription-index');
        };
    }
}

export const RenewSubscriptionSummaryComponent: ng.IComponentOptions = {
    template: require('./renew-subscription-summary.html'),
    controller: RenewSubscriptionSummaryController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/renew-subscription-summary/renew-subscription-summary.ts